import { createTheme, alpha } from '@mui/material/styles';

// ─── INDESAP Brand Colors ─────────────────────────────────────────────────
const INDESAP = {
  navy: '#111111',
  navyLight: '#2d2d2d',
  navyDark: '#000000',
  cyan: 'rgb(132, 0, 255)',
  cyanDark: '#00A8CC',
  white: '#FFFFFF',
  background: '#F5F7FA',
  surface: '#FFFFFF',
  surfaceAlt: '#EEF2F7',
  text: '#1A1A2E',
  textSecondary: '#58627A',
  success: '#00C853',
  warning: '#FF6D00',
  error: '#D50000',
  info: '#2979FF'
};

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: INDESAP.navy,
      light: INDESAP.navyLight,
      dark: INDESAP.navyDark,
      contrastText: INDESAP.white
    },
    secondary: {
      main: INDESAP.cyan,
      dark: INDESAP.cyanDark,
      contrastText: INDESAP.navy
    },
    background: {
      default: INDESAP.background,
      paper: INDESAP.surface
    },
    text: {
      primary: INDESAP.text,
      secondary: INDESAP.textSecondary
    },
    success: { main: INDESAP.success },
    warning: { main: INDESAP.warning },
    error: { main: INDESAP.error },
    info: { main: INDESAP.info }
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica Neue", Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: '-0.02em' },
    h2: { fontWeight: 700, letterSpacing: '-0.01em' },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.02em' }
  },
  shape: {
    borderRadius: 4
  },
  shadows: [
    'none',
    '0px 1px 3px rgba(27,43,75,0.08)',
    '0px 2px 8px rgba(27,43,75,0.10)',
    '0px 4px 16px rgba(27,43,75,0.12)',
    '0px 6px 24px rgba(27,43,75,0.14)',
    '0px 8px 32px rgba(27,43,75,0.16)',
    ...Array(19).fill('0px 8px 32px rgba(27,43,75,0.16)')
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: '8px 20px',
          fontWeight: 600,
          boxShadow: 'none',
          '&:hover': { boxShadow: '0px 4px 12px rgba(0,0,0,0.25)' }
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
          color: '#ffffff',
          '&:hover': {
            background: 'linear-gradient(135deg, #000000 0%, #1a1a1a 100%)'
          },
          '&.Mui-disabled': {
            background: '#2d2d2d',
            color: '#777777'
          }
        },
        containedSecondary: {
          color: INDESAP.navy,
          fontWeight: 700
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          boxShadow: '0px 2px 12px rgba(27,43,75,0.08)',
          border: '1px solid rgba(27,43,75,0.06)'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: { borderRadius: 4 }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 4,
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: INDESAP.navyLight
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: INDESAP.navy,
              borderWidth: 2
            }
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500, fontSize: '0.75rem' }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: INDESAP.background,
            color: INDESAP.text,
            fontWeight: 600,
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: 'linear-gradient(180deg, #000000 0%, #111111 100%)',
          color: INDESAP.white,
          borderRadius: 0
        }
      }
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          margin: '1px 6px',
          '&.Mui-selected': {
            backgroundColor: alpha(INDESAP.cyan, 0.15),
            '&:hover': { backgroundColor: alpha(INDESAP.cyan, 0.22) }
          },
          '&:hover': {
            backgroundColor: alpha(INDESAP.white, 0.08)
          }
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: INDESAP.white,
          color: INDESAP.text,
          boxShadow: '0px 1px 4px rgba(27,43,75,0.08)'
        }
      }
    }
  }
});

export default theme;
export { INDESAP };
